'use client'

import { createContext, useContext, type Key } from 'react'

export const AccordionContext = createContext<Key | undefined>(undefined)

export function useAccordion() {
  return useContext(AccordionContext)
}
